module.exports = __webpack_public_path__ + "static/media/img-default-avatar.be0043b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img-default-avatar.png
// module id = 1465
// module chunks = 3